module.exports = __webpack_public_path__ + "static/esfera.ce9775f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/esfera.png
// module id = 529
// module chunks = 56635243537030